if (!customElements.get('dep4-collection-filters')) {
  customElements.define('dep4-collection-filters', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.collectionRoot = this.closest('collection-component');
      // Rendered directly inside Dawn's desktop filters and mobile drawer.
      // Never move or display a second block above the collection grid.
      this.hidden = false;
      this.addEventListener('input', event => event.stopPropagation());
      this.status = this.querySelector('[role="status"]');
      this.selects = [...this.querySelectorAll('select')];
      this.selects.forEach(s => s.disabled = true);
      this.addEventListener('change', event => { event.stopPropagation(); this.apply(); });
      this.querySelector('button').addEventListener('click', () => {
        this.selects.forEach(s => s.value = '');
        window.location.assign(window.location.href);
      });
      this.load();
    }
    async load() {
      try {
        const url = new URL(this.dataset.url, location.origin);
        const current = new URL(location.href);
        current.searchParams.forEach((v, k) => {
          if (k === 'sort_by' || k.startsWith('filter.')) url.searchParams.append(k, v);
        });
        url.searchParams.set('section_id', this.dataset.section);
        const getPage = async page => {
          const request = new URL(url);
          request.searchParams.set('page', page);
          const response = await fetch(request);
          if (!response.ok) throw new Error('Collection could not be loaded');
          return new DOMParser().parseFromString(await response.text(), 'text/html');
        };
        const first = await getPage(1);
        const pagesNode = first.querySelector('[data-dep4-pages]');
        if (!pagesNode) throw new Error('Missing collection pages');
        const pages = Number(pagesNode.dataset.dep4Pages);
        const documents = [first];
        for (let page = 2; page <= pages; page++) documents.push(await getPage(page));
        this.cards = documents.flatMap(doc => [...doc.querySelectorAll('#product-grid > [data-dep4-handle]')]);
        const values = {gender: new Set(), colour: new Set(), size: new Set()};
        this.products = this.cards.map(card => {
          const options = JSON.parse(card.dataset.dep4Options);
          const variants = JSON.parse(card.dataset.dep4Variants);
          const colourIndex = options.findIndex(o => /^(color|colour)$/i.test(o));
          const sizeIndex = options.findIndex(o => /^size$/i.test(o));
          const gender = card.dataset.dep4Gender.trim();
          if (gender) values.gender.add(gender);
          variants.forEach(v => {
            if (colourIndex >= 0) values.colour.add(v.options[colourIndex]);
            if (sizeIndex >= 0) values.size.add(v.options[sizeIndex]);
          });
          return {card, variants, colourIndex, sizeIndex, gender};
        });
        this.selects.forEach(select => {
          const list = [...values[select.dataset.key]];
          const sizes = ['XXS','XS','S','M','L','XL','XXL','2XL','3XL','4XL','5XL'];
          list.sort((a,b) => select.dataset.key === 'size' && sizes.includes(a) && sizes.includes(b) ? sizes.indexOf(a)-sizes.indexOf(b) : a.localeCompare(b, undefined, {numeric:true}));
          list.forEach(value => select.add(new Option(value, value)));
          select.disabled = !list.length;
        });
        this.status.textContent = values.gender.size ? 'Choose a filter to refine this collection.' : 'Colour and Size ready. Gender needs product assignments.';
        // Full navigation for native price/sort changes keeps the custom data in sync.
        this.nativeChange = event => {
          if (event.target.closest('dep4-collection-filters')) return;
          const form = event.target.closest('facet-filters-form form');
          if (!form) return;
          event.stopImmediatePropagation();
          this.status.textContent = 'Updating collection…';
          clearTimeout(this.reloadTimer);
          this.reloadTimer = setTimeout(() => {
            const destination = new URL(location.href);
            destination.search = new URLSearchParams(new FormData(form)).toString();
            destination.searchParams.delete('page');
            window.location.assign(destination);
          }, 700);
        };
        this.collectionElement = this.closest('collection-component');
        this.collectionElement.addEventListener('input', this.nativeChange, true);
        this.collectionElement.addEventListener('change', this.nativeChange, true);
      } catch (error) {
        this.status.textContent = 'Filters could not load. Refresh to try again. Your collection is still available below.';
      }
    }
    apply() {
      if (!this.products) return;
      const selected = Object.fromEntries(this.selects.map(s => [s.dataset.key, s.value]));
      const matches = this.products.filter(p => (!selected.gender || p.gender === selected.gender) && p.variants.some(v =>
        (!selected.colour || (p.colourIndex >= 0 && v.options[p.colourIndex] === selected.colour)) &&
        (!selected.size || (p.sizeIndex >= 0 && v.options[p.sizeIndex] === selected.size))
      ));
      const grid = this.closest('collection-component').querySelector('#product-grid');
      if (!grid || grid.tagName !== 'UL') return;
      grid.replaceChildren(...matches.map(p => {
        const card = p.card.cloneNode(true);
        card.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
        return card;
      }));
      this.closest('collection-component').querySelectorAll('.pagination-wrapper').forEach(p => p.hidden = true);
      this.closest('collection-component').querySelectorAll('#ProductCount, #ProductCountDesktop').forEach(p => p.textContent = `${matches.length} products`);
      this.status.textContent = matches.length ? `${matches.length} products match.` : 'No matching products. Try another colour or size.';
    }
    disconnectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected) return;
        clearTimeout(this.reloadTimer);
        window.removeEventListener('resize', this.placeControls);
        if (this.collectionElement && this.nativeChange) {
          this.collectionElement.removeEventListener('input', this.nativeChange, true);
          this.collectionElement.removeEventListener('change', this.nativeChange, true);
        }
      });
    }
  });
}
